import { useTranslation } from 'react-i18next';
import { landingMedia } from './media';

export default function BuiltInSection() {
  const { t } = useTranslation('landing');

  const features: Array<[string, string, string]> = [
    [landingMedia.features.monetization, t('builtIn.monetization.title', 'Monetization'), t('builtIn.monetization.body', 'Configure ads, purchases, currencies, and your game economy.')],
    [landingMedia.features.analytics, t('builtIn.analytics.title', 'Analytics'), t('builtIn.analytics.body', 'Understand retention, sessions, progression, funnels, and player behavior.')],
    [landingMedia.features.players, t('builtIn.players.title', 'Players & backend'), t('builtIn.players.body', 'Manage accounts, player data, achievements, leaderboards, and game services.')],
    [landingMedia.features.liveops, t('builtIn.liveops.title', 'LiveOps'), t('builtIn.liveops.body', 'Launch events, rewards, offers, balance changes, and new content.')],
    [landingMedia.features.monitoring, t('builtIn.monitoring.title', 'Logs & monitoring'), t('builtIn.monitoring.body', 'See what is happening inside the live game and find problems quickly.')],
    [landingMedia.features.agents, t('builtIn.agents.title', 'AI Agents Studio'), t('builtIn.agents.body', 'Turn live game data into insights, recommendations, and changes to the game.')],
  ];

  return (
    <section id="platform" className="section" style={{ scrollMarginTop: 'var(--header-h)' }}>
      <h2 className="t-h2" style={{ margin: '0 0 20px', maxWidth: 900 }}>
        {t('builtIn.titleA', 'Everything behind a real game,')}{' '}
        <span className="t-accent">{t('builtIn.titleB', 'already built in.')}</span>
      </h2>
      <p className="t-lede" style={{ margin: '0 0 52px', maxWidth: 760 }}>
        {t(
          'builtIn.lede',
          'Your game is connected to Entire from the first build, so everything is already there when players arrive. No SDKs to wire up, no extra services to pay for.',
        )}
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(max(300px, calc((100% - 36px) / 3)), 1fr))',
          gap: 'var(--gap-grid)',
        }}
      >
        {features.map(([image, title, body]) => (
          <div key={title} className="card accent interactive" style={{ padding: '10px 10px 26px' }}>
            <div className="media-tinted" style={{ aspectRatio: '16 / 10', marginBottom: 22 }}>
              <img src={image} alt={title} loading="lazy" />
            </div>
            <div style={{ padding: '0 16px' }}>
              <h3 className="t-h3" style={{ letterSpacing: '-0.025em', margin: '0 0 9px' }}>
                {title}
              </h3>
              <p className="t-body" style={{ margin: 0 }}>
                {body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
